import { Grid, IconButton, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
// import { DatePicker } from "@material-ui/pickers";
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useFetch } from "../../features/customHooks/useFetch";
import { useState } from "react";
import { SearchOutlined } from "@material-ui/icons";
// import { useFetch } from "../../features/customHooks/useFetch";

const BaseInfoForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, mode = "new", loading = false, searchPostalCodeButtonClick } = props;

  const [duplications, setDuplications] = useState([]);

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
    watch,
    getValues,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: defaultValues ?? null,
  });
  const watchPostalCode = watch("postal_code");

  const [valuationHistoryFetchState, setValuationHistoryFetchParams] = useFetch();

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    isSubmitSuccessful: () => isSubmitSuccessful,
    getValues,
    duplications,
  }));

  const validate = (evt) => {
    var theEvent = evt || window.event;
    var key;
    // Handle paste
    if (theEvent.type === "paste") {
      key = theEvent.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[^0-9۰-۹]/g;
    if (regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  useEffect(() => {
    if (watchPostalCode?.length === 10) {
      const params = {
        method: "GET",
        url: `/valuation/history/${watchPostalCode}`,
      };
      setValuationHistoryFetchParams(params);
    }
  }, [watchPostalCode]);

  useEffect(() => {
    if (!valuationHistoryFetchState.loading && !valuationHistoryFetchState.error && valuationHistoryFetchState.data) {
      setDuplications(valuationHistoryFetchState?.data?.data);
      if (valuationHistoryFetchState.data?.data?.length > 0) {
        setError("postal_code", {
          type: "custom",
          message: "ارزیابی با کد پستی مشابه وجود دارد",
        });
      } else {
        clearErrors("postal_code");
      }
    }

    if (!valuationHistoryFetchState.loading && valuationHistoryFetchState.error) {
      console.log("error");
    }
  }, [valuationHistoryFetchState]);

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12} lg={3}>
          <Controller
            name='postal_code'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='کد پستی'
                size='small'
                margin='dense'
                variant='outlined'
                inputProps={{ maxlength: 10 }}
                onKeyPress={validate}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors.postal_code}
                helperText={errors.postal_code?.message}
                InputProps={{
                  endAdornment: (
                    <IconButton size='small' onClick={searchPostalCodeButtonClick}>
                      <SearchOutlined />
                    </IconButton>
                  ),
                }}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='from'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <Autocomplete
                // {...field}
                freeSolo
                options={[
                  "منزل مسکونی",
                  "‌زمین تجاری",
                  "زمین کشاورزی",
                  "باغ",
                  "زمین",
                  "کارگاه",
                  "آپارتمان",
                  "مغازه تجاری",
                  "زمین مسکونی",
                ]}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='گزارش از'
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    error={errors?.from}
                    helperText={errors?.from?.message}
                  />
                )}
                inputValue={field?.value ?? ""}
                value={field?.value ?? ""}
                onChange={(_, data) => field.onChange(data)}
                onInputChange={(data) => field.onChange(data?.target?.value)}
                // onInputChange={(e) => field.onChange(e?.target?.value?.toEnglishDigits())}
              />
            )}
          />
        </Grid>

        {/* 
        <Grid item xs={12} lg={3}>
          <Controller
            name='date'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <DatePicker
                {...field}
                variant='dialog'
                inputVariant='outlined'
                margin='dense'
                disabled
                showTodayButton
                fullWidth
                date
                label='تاریخ گزارش'
                okLabel='تأیید'
                todayLabel='امروز'
                cancelLabel='لغو'
                clearLabel='پاک کردن'
                error={errors.date}
                helperText={errors.date && "فیلد نمیتواند خالی باشد"}
                labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
              />
            )}
          />
        </Grid> */}

        <Grid item xs={12} lg={3}>
          <Controller
            name='type'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <Autocomplete
                // {...field}
                freeSolo
                options={["سند ۶ دانگ", "قباله ۶ دانگ", "سند مشاع", "قباله مشاع", "صورت وضعیت", "قولنامه عادی"]}
                noOptionsText='یافت نشد'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='نوع گزارش'
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    error={errors?.type}
                    helperText={errors?.type?.message}
                  />
                )}
                inputValue={field?.value ?? ""}
                value={field?.value ?? ""}
                onChange={(_, data) => field.onChange(data)}
                onInputChange={(data) => field.onChange(data?.target?.value)}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='city'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <TextField
                {...field}
                label='شهر'
                size='small'
                margin='dense'
                variant='outlined'
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors?.city}
                helperText={errors?.city?.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <Controller
            name='address'
            control={control}
            rules={{ required: "فیلد نمیتواند خالی باشد" }}
            render={({ field }) => (
              <TextField
                {...field}
                label='آدرس'
                size='small'
                margin='dense'
                variant='outlined'
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                error={errors?.address}
                helperText={errors?.address?.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Controller
            name='structure_type'
            control={control}
            // rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                // {...field}
                freeSolo
                options={["تیرچه بلوک", "آهن آجر", "سفت کاری"]}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='نوع سازه ساختمانی'
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    // error={errors.structure_type}
                    // helperText={errors.structure_type && "فیلد نمیتواند خالی باشد"}
                  />
                )}
                inputValue={field?.value ?? ""}
                value={field?.value ?? ""}
                onChange={(_, data) => field.onChange(data)}
                onInputChange={(data) => field.onChange(data?.target?.value)}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} lg={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={6}>
              <Controller
                name='plate'
                control={control}
                // rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label='پلاک ثبتی'
                    size='small'
                    margin='dense'
                    variant='outlined'
                    // onKeyPress={validate}
                    onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                    value={field?.value?.toPersianDigits()}
                    // error={errors.plate}
                    // helperText={errors.plate && "فیلد نمیتواند خالی باشد"}
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <Controller
                name='piece'
                control={control}
                // rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label='قطعه'
                    size='small'
                    margin='dense'
                    variant='outlined'
                    // onKeyPress={validate}
                    onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                    value={field?.value?.toPersianDigits()}
                    // error={errors.piece}
                    // helperText={errors.piece && "فیلد نمیتواند خالی باشد"}
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
});

export default BaseInfoForm;
